import React from 'react'
import { Col, Button, Row } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import * as styles from './index.css'
import MoreOptionsButton, { MoreOptionsItem } from './MoreOptionsButton'

export interface ButtonsProps {
  sideBySideLayout?: boolean
  displayTransferButton?: boolean
  handleClickOnTransfer?: () => void

  displayContributeButton?: boolean

  onContribute?: () => void
  onGuestContribute?: () => void

  displayCreateButton?: boolean
  onCreatePool?: () => void

  moreOptionsItems?: MoreOptionsItem[]

  isGuest: boolean
  onClickMoreOptions: () => void
}

const renderContributeButtons = ({
  isGuest,
  onContribute,
  onGuestContribute,
}: {
  isGuest: boolean
  onContribute: () => void
  onGuestContribute: () => void
}) => {
  if (isGuest) {
    return (
      <>
        <Button
          variant="secondary"
          className={styles.buttonContributeUser}
          onClick={onGuestContribute}
          data-testid="contributeAsGuestButton"
        >
          <Message id="flatProgress.contributeCard" />
        </Button>
        <Button
          className={styles.buttonContributeUser}
          onClick={onContribute}
          data-testid="contributeAsUserButton"
        >
          <Message id="flatProgress.contributePayPal" />
        </Button>
      </>
    )
  }

  return (
    <Button
      className={styles.buttonContributeUser}
      onClick={onContribute}
      data-testid="contributeButton"
    >
      <Message id="flatProgress.contribute" />
    </Button>
  )
}

const Buttons = (props: ButtonsProps) => {
  const {
    sideBySideLayout = true,
    displayContributeButton = false,
    displayTransferButton = false,
    handleClickOnTransfer,
    displayCreateButton = false,
    onCreatePool,
    moreOptionsItems,
    onClickMoreOptions,
  } = props

  const colContainerStyle = sideBySideLayout
    ? styles.actionButtonsContainerSideBySide
    : styles.actionButtonsContainer

  return (
    <Row
      className={styles.actionButtonsRow}
      noGutters
      data-testid="actionButtons"
    >
      <Col>
        <div className={colContainerStyle}>
          {displayTransferButton && (
            <Button
              variant="secondary"
              className={styles.buttonContributeUser}
              data-testid="transferButton"
              onClick={handleClickOnTransfer}
            >
              <Message id="flatProgress.transfer" />
            </Button>
          )}
          {displayContributeButton &&
            renderContributeButtons({
              isGuest: props.isGuest,
              onContribute: props.onContribute,
              onGuestContribute: props.onGuestContribute,
            })}
          {displayCreateButton && (
            <Button
              className={styles.buttonContributeUser}
              onClick={onCreatePool}
              data-testid="createButton"
            >
              <Message id="flatProgress.createPool" />
            </Button>
          )}
          {moreOptionsItems && moreOptionsItems.length > 0 && (
            <MoreOptionsButton
              items={moreOptionsItems}
              displayLabel={false}
              onClickMoreOptions={onClickMoreOptions}
            />
          )}
        </div>
      </Col>
    </Row>
  )
}

export default Buttons
